"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const reactstrap_1 = require("reactstrap");
const InputText_1 = require("./InputText");
const components_1 = require("./../../../components");
require("./../../styles/FormExample");
const drawerContent = (React.createElement(reactstrap_1.Nav, { vertical: true },
    React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer active", href: "#" }, "Link 1"),
    React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer", href: "#" }, "Link 2")));
const userMenu = (React.createElement(components_1.UserMenu, { userImage: React.createElement(components_1.UserMenuImage, { imageUrl: "https://s.gravatar.com/avatar/73e74124b7261376a2686fa5d1ecd9bd?s=480&r=pg", userName: "Danilo Barros" }) },
    React.createElement("div", null,
        React.createElement("div", { className: "d-block" },
            React.createElement("strong", null, "Danilo Barros")),
        React.createElement("div", { className: "d-block" }, "danilo@beakyn.com"),
        React.createElement("div", { className: "d-block" },
            React.createElement("a", { className: "dropdown-menu-link", href: "#" }, "Logout")),
        React.createElement("div", { className: "dropdown-divider" }),
        React.createElement("div", { className: "d-block" },
            React.createElement("small", null, "v1.3.1")))));
const json = {
    a: 1,
};
class FormExample extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: {
                name: '',
                email: '',
                tags: [],
            },
            debugModeEnabled: false,
        };
        this.handleChangeForField = (fieldName) => (fieldValue) => {
            const updatedFormData = Object.assign({}, this.state.data, { [fieldName]: fieldValue });
            this.setState({ data: updatedFormData });
        };
        this.handleJsonDebuggerChange = (object) => {
            this.setState({ data: object });
        };
        this.handleSubmit = (e) => {
            e.preventDefault();
            components_1.PageLoadingIndicator.start();
            setTimeout(() => components_1.PageLoadingIndicator.done(), 2000);
            components_1.Snackbar.emitMessage('Submit clicked');
        };
        this.toggleDebugMode = () => {
            this.setState({ debugModeEnabled: !this.state.debugModeEnabled });
        };
    }
    render() {
        const { data, debugModeEnabled } = this.state;
        return (React.createElement(components_1.Layout, { breadcrumbs: ['Page Title'], drawerHeaderTitle: "App Name", drawerContent: drawerContent, elementRight: userMenu, mainNavTitle: "Base Page" },
            React.createElement(components_1.Page, null,
                React.createElement(components_1.PageHeader, { title: "Page Header Title" },
                    React.createElement(components_1.Button, { className: "btn-icon btn-square", id: "btn-save", color: "link", title: "Save", onClick: () => components_1.Snackbar.emitMessage('Save clicked') },
                        React.createElement(components_1.Icon, { name: "save" })),
                    React.createElement(components_1.UncontrolledTooltip, { placement: "left", target: "btn-save" }, "Save")),
                React.createElement(components_1.PageBody, null,
                    React.createElement("section", { className: "sub-section" },
                        React.createElement(components_1.Form, { autoComplete: "off", onSubmit: this.handleSubmit },
                            React.createElement(InputText_1.InputText, { helpText: "Type your name", label: "Name", name: "name", value: data.name, onChange: this.handleChangeForField('name') }),
                            React.createElement(InputText_1.InputText, { label: "Email", name: "email", value: data.email, onChange: this.handleChangeForField('email') }),
                            React.createElement(InputText_1.InputText, { label: "Tags", name: "tags", value: data.tags, valueIsArray: true, onChange: this.handleChangeForField('tags') }),
                            React.createElement(components_1.Row, null,
                                React.createElement(components_1.Col, { sm: { offset: 3 } },
                                    React.createElement(components_1.FormActions, { objectToDebug: data, onClickBackButton: () => components_1.Snackbar.emitMessage('Back clicked'), onChangeDebugObject: this.handleJsonDebuggerChange }))))),
                    React.createElement("section", { className: "sub-section" },
                        React.createElement(components_1.Row, null,
                            React.createElement(components_1.Col, { sm: { offset: 3 } },
                                React.createElement(components_1.DangerZone, { onRemoveConfirmation: () => components_1.Snackbar.emitMessage('Remove confirmed'), text: "Once you delete this data, there is no going back. Please be certain.", modalTitle: "Delete", modalMessage: "Are you sure you want to permanently remove this data?" })))))),
            React.createElement(components_1.Snackbar, null)));
    }
}
exports.FormExample = FormExample;



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/FormExample.tsx
// module id = 236
// module chunks = 0